import { useDeepEqualValue } from '@superdispatch/hooks';
import { createContext } from 'react';
import { useNullableContext } from 'shared/hooks/useNullableContext';
import { useUserPermissions } from 'shared/modules/permission/PermissionAPI';
import { UpdateParams, useLocationParams } from 'shared/routing/LocationParams';
import { TripsPageParams, tripsPageParamsSchema } from './TripsDTO';

interface TripsProviderProps {
  hasNotManageAccess: boolean;
  params: TripsPageParams;
  updateParams: UpdateParams<TripsPageParams>;
}

const context = createContext<null | TripsProviderProps>(null);

export function useTripsContext(): TripsProviderProps {
  return useNullableContext('TripsProvider', context);
}

export function TripsProvider({ children }: { children: React.ReactNode }) {
  const [params, updateParams] = useLocationParams({
    zodSchema: tripsPageParamsSchema,
    persistName: 'trips-filter',
  });

  const { data: userPermission } = useUserPermissions();

  const hasTripsManagePermission = userPermission?.trips?.can_manage;

  const hasNotManageAccess = !hasTripsManagePermission;

  const ctx = useDeepEqualValue({ hasNotManageAccess, params, updateParams });

  return <context.Provider value={ctx}>{children}</context.Provider>;
}
